import React from "react";

export default function WhatsAppIcon({ size = 18, strokeWidth = 1.6, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M21 12a9 9 0 0 1-13.43 7.82L3 21l1.21-4.46A9 9 0 1 1 21 12Z" />
      <path d="M8.5 9.5c.2 1.6 1 3 2 4 1 1 2.4 1.8 4 2 .6.05 1.1-.45 1.2-1l.1-.7-2-1-1 .8c-.7-.4-1.4-1.1-1.8-1.8l.8-1-1-2-.7.1c-.55.1-1.05.6-1 1.2Z" />
    </svg>
  );
}
